module.exports = __webpack_public_path__ + "img/new_manna_ministries.ab6b4c7a.png";